import { default as setFeatureFlag } from './setFeatureFlag';
import { FeatureName } from '../store/featureDefinitions';
import getStore from '../store/Store';
import { clearLocalStorageOverrides } from '../utils/overrides/localStorageOverrides';
import { action } from 'satcheljs/lib/legacy';

export default action('resetFeatureFlags')(function resetFeatureFlags() {
    for (let featureName of getStore().featureFlags.keys()) {
        setFeatureFlag(featureName as FeatureName, !!getStore().defaultFlags.get(featureName));
    }

    clearLocalStorageOverrides();
});
